import { H2 } from '@/common/ui'
import { LabelInputRadio } from '@/common/ui/LabelInputRadio'
import { APPLICATION_COPY } from '@/locales/en'
import { ACCOUNT_PARTICIPANT_ACCESS_PROFILES, type AccountParticipantAccessProfile } from '@/account/type'
import type { AddAccountParticipantDraft } from '../types'

type Props = {
    participant: AddAccountParticipantDraft
    onAccessProfileChange: (accessProfile: AccountParticipantAccessProfile) => void
    supportedAccessProfiles?: AccountParticipantAccessProfile[]
}

const defaultAccessProfileOptions = [
    ACCOUNT_PARTICIPANT_ACCESS_PROFILES.NONE,
    ACCOUNT_PARTICIPANT_ACCESS_PROFILES.VIEW,
    ACCOUNT_PARTICIPANT_ACCESS_PROFILES.TRADE,
] as const

export function AddAccountParticipantAccessReviewStep({
    participant,
    onAccessProfileChange,
    supportedAccessProfiles = [...defaultAccessProfileOptions],
}: Props) {
    const selectedAccessProfile = participant.accessProfile ?? ACCOUNT_PARTICIPANT_ACCESS_PROFILES.NONE

    return (
        <div className="self-stretch inline-flex flex-col justify-start items-start">
            <div className="self-stretch flex flex-col justify-start items-start gap-12">
                <div className="self-stretch flex flex-col justify-start items-start gap-6">
                    <div className="self-stretch flex flex-col justify-start items-start gap-6">
                        <div className="self-stretch flex flex-col justify-start items-start gap-4">
                            <H2 className="self-stretch justify-start text-brand-forest text-3xl font-normal font-['Serious Sans'] leading-10 mb-0">
                                {APPLICATION_COPY.participantAccessReview.title}
                            </H2>
                            <div className="self-stretch justify-start text-black text-base font-normal font-['Inter'] leading-6">
                                {APPLICATION_COPY.participantAccessReview.description}
                            </div>
                        </div>
                        <div className="self-stretch flex flex-col justify-start items-start gap-4">
                            {supportedAccessProfiles.map((accessProfile) => {
                                const optionCopy = APPLICATION_COPY.participantAccessReview.options[accessProfile]
                                const isViewOnly = accessProfile === ACCOUNT_PARTICIPANT_ACCESS_PROFILES.VIEW

                                return (
                                    <LabelInputRadio
                                        key={accessProfile}
                                        id={`participant-access-${accessProfile.toLowerCase()}`}
                                        name="participant-access-profile"
                                        title={optionCopy.title}
                                        description={optionCopy.description}
                                        checked={selectedAccessProfile === accessProfile}
                                        disabled={isViewOnly}
                                        badgeText={
                                            isViewOnly
                                                ? APPLICATION_COPY.participantAccessReview.viewOnlyComingSoonLabel
                                                : undefined
                                        }
                                        onChange={() => {
                                            if (!isViewOnly) {
                                                onAccessProfileChange(accessProfile)
                                            }
                                        }}
                                        className="max-w-none"
                                    />
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
